import { baseApi } from "./baseApi";

const DASHBOARD_BASE_URL = "/dashboard";

export const dashboardApi = baseApi.injectEndpoints({
  tagTypes: ["Dashboard"],

  endpoints: (builder) => ({
    getAppOverviewStats: builder.query({
      query: () => ({ url: `${DASHBOARD_BASE_URL}/overview` }),
    }),

    getAdminOverviewStats: builder.query({
      query: () => ({ url: `${DASHBOARD_BASE_URL}/my-overview` }),
    }),

    getPerformanceStats: builder.query({
      query: () => ({ url: `${DASHBOARD_BASE_URL}/performance` }),
    }),

    getLeaderBoardStats: builder.query({
      query: () => ({ url: `${DASHBOARD_BASE_URL}/leaderboard` }),
    }),

    getReferralOverviewStats: builder.query({
      query: () => ({ url: `${DASHBOARD_BASE_URL}/referral-overview` }),
    }),

    // New endpoint for getDashboardStats controller
    getDashboardStats: builder.query({
      query: ({ fromDate, toDate }) => ({
        url: `${DASHBOARD_BASE_URL}/stats`,
        method: "GET",
        params: { fromDate, toDate },
      }),
    }),

    // New endpoint for getDashboardStats controller
    // driverProfileDashboardStats: builder.query({
    //   query: () => ({ url: `${DASHBOARD_BASE_URL}/driverProfileStats` }),
    // }),

    getLineChartStats: builder.query({
      query: () => ({ url: `${DASHBOARD_BASE_URL}/lineChart` }),
    }),

    getPaiChartStats: builder.query({
      query: () => ({ url: `${DASHBOARD_BASE_URL}/paiChart` }),
    }),

    getGaugeStats: builder.query({
      query: () => ({ url: `${DASHBOARD_BASE_URL}/gauge` }),
    }),
    getShipmentOperationCount: builder.query({
      query: () => ({ url: `${DASHBOARD_BASE_URL}/shipmentOperationCount` }),
    }),
    getVendorDashboardStats: builder.query({
      query: () => ({ url: `vendor/vendor-stats` }),
    }),
    getVendorShipmentStats: builder.query({
      query: ({ period }) => ({
        url: `${DASHBOARD_BASE_URL}/vendorLineChart`,
        params: { period },
      }),
    }),
    getStaffShipmentStats: builder.query({
      query: ({ period }) => ({
        url: `${DASHBOARD_BASE_URL}/staff-chart`,
        params: { period },
      }),
    }),

    getCustomerDashboardStats: builder.query({
      query: () => ({ url: `${DASHBOARD_BASE_URL}/customer-dashboard` }),
    }),

    getVendorProfileDashboardStats: builder.query({
      query: () => ({ url: `${DASHBOARD_BASE_URL}/vendor-dashboard` }),
    }),
    getVendorCODChargeOverview: builder.query({
  query: () => ({ url: `${DASHBOARD_BASE_URL}/vendor-cod-charge-overview` }),
}),
    getStaffPortalDashboardStats: builder.query({
      query: () => ({ url: `${DASHBOARD_BASE_URL}/staff-dashboard` }),
    }),

    getTotalDeliveredShipmentForCustomer: builder.query({
      query: () => ({ url: `${DASHBOARD_BASE_URL}/delivered-shipments` }),
    }),
    getDashboardPriceStats: builder.query({
      query: ({ fromDate, toDate }) => ({
        url: `${DASHBOARD_BASE_URL}/priceChart`,
        params: { fromDate, toDate },
      }),
    }),
  }),
});

export const {
  useGetAppOverviewStatsQuery,
  useGetAdminOverviewStatsQuery,
  useGetLeaderBoardStatsQuery,
  useGetPerformanceStatsQuery,
  // useDriverProfileDashboardStats,
  useGetReferralOverviewStatsQuery,
  useGetDashboardStatsQuery,
  useGetLineChartStatsQuery,
  useGetPaiChartStatsQuery,
  useGetGaugeStatsQuery,
  useGetShipmentOperationCountQuery,
  useGetVendorDashboardStatsQuery,
  useGetCustomerDashboardStatsQuery,
  useGetVendorProfileDashboardStatsQuery,
  useGetStaffPortalDashboardStatsQuery,
  useGetVendorCODChargeOverviewQuery,
  useGetTotalDeliveredShipmentForCustomerQuery,
  useGetVendorShipmentStatsQuery,
  useGetStaffShipmentStatsQuery,
  useGetDashboardPriceStatsQuery,
} = dashboardApi;
